import React from "react";
import { Link } from "react-router-dom";
import Layout from "../../components/Layout";
import styles from './NotFound.module.css';

export default function NotFound() {
    return (
        <Layout>
            <div className={styles.notFoundContainer}>
                <h1>404</h1>
                <p>Страница не найдена</p>
                <Link to="/" className={styles.notFoundLink}>
                    Вернуться на главную
                </Link>
            </div>
        </Layout>
    );
}
